const questions = [
    {
      id: 1,
      question: "What is the capital of France?",
      options: ["Berlin", "Madrid", "Paris", "Rome"],
      correctAnswer: "Paris",
    },
    {
      id: 2,
      question: "Which planet is known as the Red Planet?",
      options: ["Earth", "Mars", "Jupiter", "Saturn"],
      correctAnswer: "Mars",
    },
    {
      id: 3,
      question: "Who wrote 'Romeo and Juliet'?",
      options: ["William Shakespeare", "Leo Tolstoy", "Charles Dickens", "Mark Twain"],
      correctAnswer: "William Shakespeare",
    },
    {
      id: 4,
      question: "What is the boiling point of water?",
      options: ["90°C", "100°C", "120°C", "80°C"],
      correctAnswer: "100°C",
    },
    {
      id: 5,
      question: "Which element has the chemical symbol 'O'?",
      options: ["Oxygen", "Gold", "Osmium", "Oganesson"],
      correctAnswer: "Oxygen",
    },
    {
      id: 6,
      question: "What is the largest mammal in the world?",
      options: ["Elephant", "Blue Whale", "Giraffe", "Rhino"],
      correctAnswer: "Blue Whale",
    },
    {
      id: 7,
      question: "Which country is known as the Land of the Rising Sun?",
      options: ["China", "Japan", "Thailand", "Vietnam"],
      correctAnswer: "Japan",
    },
    {
      id: 8,
      question: "What is the square root of 64?",
      options: ["6", "7", "8", "9"],
      correctAnswer: "8",
    },
    {
      id: 9,
      question: "Who was the first man to walk on the moon?",
      options: ["Neil Armstrong", "Buzz Aldrin", "Yuri Gagarin", "Michael Collins"],
      correctAnswer: "Neil Armstrong",
    },
    {
      id: 10,
      question: "Which language is the most spoken worldwide?",
      options: ["Spanish", "Mandarin Chinese", "English", "Hindi"],
      correctAnswer: "Mandarin Chinese",
    },
    {
      id: 11,
      question: "Which gas do plants absorb from the atmosphere?",
      options: ["Oxygen", "Nitrogen", "Carbon Dioxide", "Hydrogen"],
      correctAnswer: "Carbon Dioxide",
    },
    {
      id: 12,
      question: "What is the chemical formula for water?",
      options: ["H2O", "O2", "CO2", "NaCl"],
      correctAnswer: "H2O",
    },
    {
      id: 13,
      question: "Who discovered gravity?",
      options: ["Albert Einstein", "Isaac Newton", "Galileo Galilei", "Nikola Tesla"],
      correctAnswer: "Isaac Newton",
    },
    {
      id: 14,
      question: "What is the hardest natural substance on Earth?",
      options: ["Gold", "Iron", "Diamond", "Graphite"],
      correctAnswer: "Diamond",
    },
    {
      id: 15,
      question: "What is the largest planet in our solar system?",
      options: ["Earth", "Mars", "Jupiter", "Saturn"],
      correctAnswer: "Jupiter",
    },
    {
      id: 16,
      question: "Who painted the Mona Lisa?",
      options: ["Vincent van Gogh", "Pablo Picasso", "Leonardo da Vinci", "Claude Monet"],
      correctAnswer: "Leonardo da Vinci",
    },
    {
      id: 17,
      question: "Which country is home to the kangaroo?",
      options: ["South Africa", "India", "Australia", "Brazil"],
      correctAnswer: "Australia",
    },
    {
      id: 18,
      question: "What is the currency of Japan?",
      options: ["Yen", "Won", "Yuan", "Baht"],
      correctAnswer: "Yen",
    },
    {
      id: 19,
      question: "Which ocean is the largest?",
      options: ["Atlantic Ocean", "Indian Ocean", "Pacific Ocean", "Arctic Ocean"],
      correctAnswer: "Pacific Ocean",
    },
    {
      id: 20,
      question: "What is the speed of light?",
      options: ["300,000 km/s", "150,000 km/s", "450,000 km/s", "600,000 km/s"],
      correctAnswer: "300,000 km/s",
    },
    {
      id: 21,
      question: "What is the most abundant gas in the Earth's atmosphere?",
      options: ["Oxygen", "Hydrogen", "Nitrogen", "Carbon Dioxide"],
      correctAnswer: "Nitrogen",
    },
    {
      id: 22,
      question: "Who invented the telephone?",
      options: ["Alexander Graham Bell", "Thomas Edison", "Nikola Tesla", "Samuel Morse"],
      correctAnswer: "Alexander Graham Bell",
    },
    {
      id: 23,
      question: "Which country has the most islands?",
      options: ["Canada", "Sweden", "Indonesia", "Australia"],
      correctAnswer: "Sweden",
    },
    {
      id: 24,
      question: "Which metal is liquid at room temperature?",
      options: ["Mercury", "Lead", "Gold", "Silver"],
      correctAnswer: "Mercury",
    },
    {
      id: 25,
      question: "What is the smallest country in the world?",
      options: ["Monaco", "Vatican City", "San Marino", "Liechtenstein"],
      correctAnswer: "Vatican City",
    }
  ];
  
  export default questions;
  